import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Loader } from '@hivebrite/design-system/Loader';

import {
  FilePreviewContent,
  FilePreviewNoContent,
} from 'hb-react/shared/components/FilePreview/Common/Content';

const Content = ({ categories, file, isLoading = false }) => {
  if (isLoading) {
    return (
      <WrapperStyled>
        <Loader size={50} />
      </WrapperStyled>
    );
  }

  if (!file && !isLoading) {
    return (
      <WrapperStyled>
        <FilePreviewNoContent />
      </WrapperStyled>
    );
  }

  return (
    <WrapperStyled>
      <FilePreviewContent filePreview={file} categories={categories} />
    </WrapperStyled>
  );
};

Content.propTypes = {
  categories: PropTypes.array,
  file: PropTypes.object,
  isLoading: PropTypes.bool,
};

export default Content;

const WrapperStyled = styled(Box).attrs({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'center',
})``;
